import { CleaningModeEnum } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

export const toggleCleaningZone = (cleaningZones: string[], areaId: string): string[] =>
  cleaningZones.includes(areaId) ? cleaningZones.filter(id => id !== areaId) : [...cleaningZones, areaId];

export const isCleaningZonesSelectionValid = (cleaningMode: CleaningModeEnum, cleaningZones: string[]): boolean =>
  cleaningMode !== CleaningModeEnum.Area || cleaningZones.length > 0;

export const areStringArraysEqual = (left: string[] = [], right: string[] = []): boolean =>
  left.length === right.length && left.every((value, index) => value === right[index]);
